module.exports = {
  ascii: require('./tables/ascii.json'),
  ascii_bibtex_creator: require('./tables/ascii-bibtex-creator.json'),
  unicode: require('./tables/unicode.json'),
  latex: require('./tables/latex.json'),
  diacritics: require('./tables/diacritics.json'),
};
